/* Djurslottet DATA-DRIVEN demand badge + LOW-STOCK badge (COMPACT single-line).
   Demand: reads data-dj-sold (metafield custom.dj_sold_30d, Shopify Flow).
   sold>=bestThreshold => 'Bästsäljare'; else sold>=threshold => VARIED phrase (djb2 hash).
   Low stock: data-dj-lowstock="1" => 'Låg lagersaldo' (NEVER a number); optional BLINKING icon.
   EMPTY label => icon only. Animate toggle per tier (fast/best/low). Separate text size
   for cards (fs) vs product page (ppFs). Product page (.djb-pp): ppPlacement 'price'
   (under price) or 'image' (overlay top-left of first product image). Icons selectable.
   Idempotent: guards by data-attr AND by DESCENDANT presence (a card-gallery slideshow can
   wrap the pill inside a slide, so a :scope> check missed it and a second pill was added ->
   duplicate "Kundfavorit"). Guards + a dedup pass now use descendant scope, so max ONE
   demand + ONE low pill per card, even after carousel clones / re-renders / slide wrapping.
   Config from JSON in sections/dj-demand-badge.liquid. MutationObserver. */
(function () {
  var DEF = {
    threshold: 20, bestThreshold: 50,
    bestsellerLabel: 'Bästsäljare',
    phrases: ['Säljer snabbt', 'Populär just nu', 'Het just nu', 'Kundfavorit', 'Många köper nu'],
    subtemplate: '{n} sålda', showCount: true, pos: 'tl', ppPlacement: 'price',
    iconFast: 'flame', iconBest: 'crown', animateFast: true, animateBest: false,
    bg: '#FFF3DC', text: '#864e1b', border: '#EBD9AE', iconColor: '#E4572E',
    bestBg: '#04734F', bestText: '#ffffff', bestBorder: '#04734F', bestIcon: '#FFD97A',
    lowLabel: 'Låg lagersaldo', lowIcon: 'box', lowPos: 'bl', lowBlink: true,
    lowBg: '#FFF0E0', lowText: '#B4530E', lowBorder: '#F2C79A', lowIconColor: '#F5811F',
    fs: 11, ppFs: 14, inset: 8, pv: 3, ph: 9, radius: 100
  };
  var CFG = null;
  var LABEL_KEYS = { bestsellerLabel: 1, lowLabel: 1 };
  function svg(inner, name) { return '<svg class="djb__ic" viewBox="0 0 24 24" aria-hidden="true"' + (name ? ' data-dj-icon="' + name + '" focusable="false"' : '') + '>' + inner + '</svg>'; }
  var ICONS = {
    paw: function () { return svg('<ellipse cx="4.6" cy="10" rx="1.8" ry="2.5" transform="rotate(-28 4.6 10)"/><ellipse cx="9.3" cy="5.8" rx="1.9" ry="2.7" transform="rotate(-12 9.3 5.8)"/><ellipse cx="14.7" cy="5.8" rx="1.9" ry="2.7" transform="rotate(12 14.7 5.8)"/><ellipse cx="19.4" cy="10" rx="1.8" ry="2.5" transform="rotate(28 19.4 10)"/><path d="M12 11.6c-2.1 0-3.2 1.7-4.5 3.3l-2.1 2.3c-1.2 1.3-1.1 3.2.2 4.2 1.1.9 2.7.8 4 .3 1.6-.6 3.2-.6 4.8 0 1.3.5 2.9.6 4-.3 1.3-1 1.4-2.9.2-4.2l-2.1-2.3c-1.3-1.6-2.4-3.3-4.5-3.3Z"/>', 'paw'); },
    flame: function () { return svg('<path d="M12 2c1 3-1 4-2 6-1 1.7-2 3-2 5a6 6 0 0 0 12 0c0-3-2-5-3-7-.6 1.4-1.6 2-2.5 1C13 6 13 4 12 2z"/>'); },
    crown: function () { return svg('<path d="M3 7l4 4 5-6 5 6 4-4-2 12H5L3 7z"/>'); },
    star: function () { return svg('<path d="M12 2l2.9 6.3 6.9.6-5.2 4.5 1.6 6.7L12 17l-6.2 3.6 1.6-6.7L2.2 9.4l6.9-.6z"/>'); },
    heart: function () { return svg('<path d="M12 21s-7-4.4-9.3-8.6C1 9 2.6 5.5 6 5.5c2 0 3.2 1.2 4 2.3.8-1.1 2-2.3 4-2.3 3.4 0 5 3.5 3.3 6.9C19 16.6 12 21 12 21z"/>'); },
    bolt: function () { return svg('<path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z"/>'); },
    box: function () { return svg('<path d="M12 2l9 5v10l-9 5-9-5V7l9-5zm0 2.2L5 8l7 3.8L19 8l-7-3.8zM4 9.6V16l7 3.9v-6.5L4 9.6zm16 0l-7 3.8v6.5l7-3.9V9.6z"/>'); },
    clock: function () { return svg('<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 5v5l4 2-.8 1.7L11 13V7h2z"/>'); }
  };
  function readCfg() {
    var cfg = {}; for (var k in DEF) cfg[k] = DEF[k];
    var el = document.querySelector('[data-dj-badge-config]');
    if (el) { try { var j = JSON.parse(el.textContent || '{}'); for (var key in j) { var v = j[key]; if (v === undefined || v === null) continue; if (v === '' && !LABEL_KEYS[key]) continue; cfg[key] = v; } } catch (e) {} }
    if (!Array.isArray(cfg.phrases) || !cfg.phrases.length) cfg.phrases = DEF.phrases;
    return cfg;
  }
  function hashId(s) { s = String(s || ''); var h = 5381; for (var i = 0; i < s.length; i++) { h = ((h * 33) ^ s.charCodeAt(i)) >>> 0; } return h; }
  function esc(s) { return String(s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }
  function iconHtml(name) { return (name && name !== 'none' && ICONS[name]) ? ICONS[name]() : ''; }
  function hasText(s) { return s != null && String(s).trim() !== ''; }

  function isCustomerFavorite(label) { return String(label || '').trim().toLowerCase() === 'kundfavorit'; }

  function refreshFavoriteIcon(el) {
    // Saved cards and rerendered product anchors may contain the previous star.
    var pills = el.querySelectorAll('.djb--fast, .djb--best');
    for (var i = 0; i < pills.length; i++) {
      var label = pills[i].querySelector('.djb__label');
      if (!label || !isCustomerFavorite(label.textContent)) continue;
      var icon = pills[i].querySelector('.djb__ic');
      if (icon && icon.getAttribute('data-dj-icon') === 'paw') continue;
      if (icon) icon.remove();
      pills[i].insertAdjacentHTML('afterbegin', ICONS.paw());
    }
  }

  function build(el, big) {
    refreshFavoriteIcon(el);
    if (el.getAttribute('data-dj-badged') === '1') return false;
    // Descendant scope (not :scope >): a card-gallery slideshow can wrap the existing pill
    // inside a slide element, which used to defeat the direct-child guard and add a 2nd pill.
    if (el.querySelector('.djb--fast, .djb--best')) { el.setAttribute('data-dj-badged', '1'); return false; }
    var soldRaw = el.getAttribute('data-dj-sold');
    if (soldRaw === null) { return false; }
    var sold = parseInt(soldRaw, 10) || 0;
    var bestFlag = el.getAttribute('data-dj-bestseller') === '1';
    var tier, label;
    if (bestFlag || (CFG.bestThreshold > 0 && sold >= CFG.bestThreshold)) { tier = 'best'; label = CFG.bestsellerLabel; }
    else if (sold >= CFG.threshold) {
      tier = 'fast';
      var pid = el.getAttribute('data-product-id') || el.getAttribute('data-dj-pid') || String(sold);
      label = CFG.phrases[hashId(pid) % CFG.phrases.length];
    } else { el.setAttribute('data-dj-badged', '1'); return false; }
    el.setAttribute('data-dj-badged', '1');
    var ic = iconHtml(isCustomerFavorite(label) ? 'paw' : (tier === 'best' ? CFG.iconBest : CFG.iconFast));
    var showLabel = hasText(label);
    if (!ic && !showLabel) return false;
    var html = ic;
    if (showLabel) html += '<span class="djb__label">' + esc(label) + '</span>';
    if (showLabel && CFG.showCount && sold > 0 && CFG.subtemplate) html += '<span class="djb__sub">' + esc(CFG.subtemplate.replace('{n}', sold)) + '</span>';
    var anim = (((tier === 'fast' && CFG.animateFast) || (tier === 'best' && CFG.animateBest)) && ic) ? ' djb--anim' : '';
    var pill = document.createElement('span');
    pill.className = 'djb djb--' + tier + ' djb--' + CFG.pos + (big ? ' djb--big' : '') + (showLabel ? '' : ' djb--iconly') + anim;
    pill.innerHTML = html;
    el.appendChild(pill);
    return true;
  }

  function buildLow(el, big) {
    if (el.getAttribute('data-dj-low-badged') === '1') return false;
    el.setAttribute('data-dj-low-badged', '1');
    if (el.getAttribute('data-dj-lowstock') !== '1') return false;
    if (el.querySelector('.djb--low')) return false;
    var ic = iconHtml(CFG.lowIcon);
    var showLabel = hasText(CFG.lowLabel);
    if (!ic && !showLabel) return false;
    var html = ic;
    if (showLabel) html += '<span class="djb__label">' + esc(CFG.lowLabel) + '</span>';
    var pill = document.createElement('span');
    pill.className = 'djb djb--low djb--' + CFG.lowPos + (big ? ' djb--big' : '') + (showLabel ? '' : ' djb--iconly') + ((CFG.lowBlink && ic) ? ' djb--blink' : '');
    pill.innerHTML = html;
    el.appendChild(pill);
    return true;
  }

  // Defensive: never allow more than ONE demand pill or ONE low pill per card.
  function dedupCard(card) {
    if (!card) return;
    var dem = card.querySelectorAll('.djb--fast, .djb--best');
    for (var a = 1; a < dem.length; a++) dem[a].remove();
    var low = card.querySelectorAll('.djb--low');
    for (var b = 1; b < low.length; b++) low[b].remove();
  }

  function firstImageHost() {
    var imgs = document.querySelectorAll('.product-media__image, .product-media img, media-gallery img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.closest('.dialog-zoomed-gallery') || im.closest('zoom-dialog')) continue;
      if (im.offsetParent === null) continue;
      var r = im.getBoundingClientRect();
      if (r.width < 60 || r.height < 60) continue;
      return im.closest('.product-media') || im.parentElement;
    }
    return null;
  }
  function isMainProductAnchor(el) {
    return location.pathname.indexOf('/products/') !== -1 &&
      !el.closest('dialog.quick-add-modal, product-card, quick-add-component');
  }

  function relocatePP() {
    var pills = document.querySelectorAll('main .djb-pp .djb');
    var validPills = [];
    for (var p = 0; p < pills.length; p++) {
      var anchor = pills[p].closest('.djb-pp');
      if (anchor && isMainProductAnchor(anchor)) validPills.push(pills[p]);
    }
    if (!validPills.length) return;
    var host = firstImageHost();
    if (!host) return;
    host.classList.add('djb-pp-host');
    var stack = host.querySelector('.djb-onimg-stack');
    if (!stack) { stack = document.createElement('div'); stack.className = 'djb-onimg-stack'; host.appendChild(stack); }
    for (var i = 0; i < validPills.length; i++) {
      var pill = validPills[i];
      pill.classList.remove('djb--big', 'djb--tl', 'djb--tr', 'djb--bl', 'djb--br');
      pill.classList.add('djb--onimg');
      stack.appendChild(pill);
    }
    var anchors = document.querySelectorAll('main .djb-pp');
    for (var a = 0; a < anchors.length; a++) {
      if (isMainProductAnchor(anchors[a]) && !anchors[a].querySelector('.djb')) anchors[a].parentNode && anchors[a].remove();
    }
  }

  function collectTargets(root, selector) {
    var out = [];
    if (!root) return out;
    var el = root.nodeType === 1 ? root : null;
    var closest = el && el.closest ? el.closest(selector) : null;
    if (closest) out.push(closest);
    if (root.querySelectorAll) {
      var nested = root.querySelectorAll(selector);
      for (var i = 0; i < nested.length; i++) {
        if (out.indexOf(nested[i]) < 0) out.push(nested[i]);
      }
    }
    return out;
  }

  function badgeAll(root) {
    if (!CFG) CFG = readCfg();
    root = root || document;
    var imgMode = CFG.ppPlacement === 'image';
    var cards = collectTargets(root, '.card-gallery[data-dj-sold], .card-gallery[data-dj-lowstock]');
    for (var i = 0; i < cards.length; i++) {
      build(cards[i], false);
      buildLow(cards[i], false);
      dedupCard(cards[i]);
    }
    var pps = collectTargets(root, 'main .djb-pp');
    for (var j = 0; j < pps.length; j++) {
      if (!isMainProductAnchor(pps[j])) continue;
      var a = build(pps[j], true);
      var b = buildLow(pps[j], true);
      if ((a || b) && !imgMode) pps[j].removeAttribute('hidden');
    }
    if (imgMode && pps.length && location.pathname.indexOf('/products/') !== -1) relocatePP();
  }

  function setVars() {
    CFG = readCfg();
    var r = document.documentElement.style;
    r.setProperty('--djb-bg', CFG.bg); r.setProperty('--djb-text', CFG.text); r.setProperty('--djb-border', CFG.border); r.setProperty('--djb-icon', CFG.iconColor);
    r.setProperty('--djb-best-bg', CFG.bestBg); r.setProperty('--djb-best-text', CFG.bestText); r.setProperty('--djb-best-border', CFG.bestBorder); r.setProperty('--djb-best-icon', CFG.bestIcon);
    r.setProperty('--djb-low-bg', CFG.lowBg); r.setProperty('--djb-low-text', CFG.lowText); r.setProperty('--djb-low-border', CFG.lowBorder); r.setProperty('--djb-low-icon', CFG.lowIconColor);
    r.setProperty('--djb-fs', CFG.fs + 'px'); r.setProperty('--djb-fs-big', CFG.ppFs + 'px'); r.setProperty('--djb-inset', CFG.inset + 'px'); r.setProperty('--djb-pv', CFG.pv + 'px'); r.setProperty('--djb-ph', CFG.ph + 'px'); r.setProperty('--djb-radius', CFG.radius + 'px');
  }
  var queuedRoots = [];
  var queuedFrame = 0;
  var targetSelector = '.card-gallery[data-dj-sold], .card-gallery[data-dj-lowstock], .djb-pp';

  function relevantRoot(node) {
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;
    if (!el) return null;
    var owner = el.closest ? el.closest(targetSelector) : null;
    if (owner) return owner;
    if (el.matches && el.matches(targetSelector)) return el;
    return el.querySelector && el.querySelector(targetSelector) ? el : null;
  }

  function queueRoot(node) {
    var root = relevantRoot(node);
    if (!root || !root.isConnected || queuedRoots.indexOf(root) >= 0) return;
    queuedRoots.push(root);
    if (queuedFrame) return;
    queuedFrame = requestAnimationFrame(function () {
      queuedFrame = 0;
      var roots = queuedRoots.slice();
      queuedRoots.length = 0;
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].isConnected) badgeAll(roots[i]);
      }
    });
  }

  function observeRoot(root) {
    if (!root || root.__djBadgeObserved) return;
    root.__djBadgeObserved = true;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        var owner = relevantRoot(mutation.target);
        if (owner && owner !== mutation.target) queueRoot(owner);
        for (var j = 0; j < mutation.addedNodes.length; j++) queueRoot(mutation.addedNodes[j]);
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function run() {
    setVars();
    badgeAll(document);
    observeRoot(document.getElementById('MainContent'));
    observeRoot(document.getElementById('quick-add-modal-content'));
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run, { once: true });

  document.addEventListener('shopify:section:load', function (event) {
    setVars();
    badgeAll(event.target);
  });
})();
